import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-exercise-start-dialog',
  templateUrl: './exercise-start-dialog.component.html',
  styleUrls: ['./exercise-start-dialog.component.css']
})
export class ExerciseStartDialogComponent implements OnInit {
  exerciseData:any ={};
  userInfo:any;
  userId:any;
  accuracy:any;
  questionsData: any;
  noOfViews:any;
  topicdata: any;
  isLastTopic: boolean;

  constructor(public router: Router, public selfLearnService: SelfLearnService, public dialog: MatDialog,public dialogRef: MatDialogRef<ExerciseStartDialogComponent>,public spinner:NgxSpinnerService) { }

  ngOnInit(): void {
    this.noOfViews = this.getNoOfViews();
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.userId = this.userInfo.userDto.userId;
    this.exerciseData.isInprogress = false;
    localStorage.removeItem('exerciseQuestions');
    localStorage.removeItem('exerciseData');
    this.getExamDetails();
    this.topicdata = JSON.parse(localStorage.getItem('selctedChapterTopics'));
    let topicId = this.selfLearnService.getTopicId();
    this.isLastTopic = this.topicdata[this.topicdata.length-1].topicId == Number(topicId) ? true :false;

  }
  getExamDetails(){
    this.spinner.show();
    this.selfLearnService.getExerciseExamDetails().subscribe((res:any) =>{
      if(!res.status){
        this.createExerciseForTopic();
      }else{
         if(res.report.length>0){
        this.exerciseData = res.report
        this.exerciseData = this.exerciseData[this.exerciseData.length-1];
        this.accuracy = this.exerciseData.attemps.length > 0?this.exerciseData.attemps[this.exerciseData.attemps.length-1]: []
        this.exerciseData.attemptnumber = this.exerciseData.attemps.length > 0? Number(this.exerciseData.attemps[this.exerciseData.attemps.length-1].attemptnumber) : 1
        let result = {
          attempt:  this.exerciseData.attemptnumber,
          percentage:  this.accuracy.accuracy,

        }
        localStorage.setItem('examresultData',JSON.stringify(result));
        if(this.exerciseData.attemps.length > 0){
         this. getExcerciseExamResponses();
        }
        this.getPracticeQuestions();
       
        localStorage.setItem('exerciseData',JSON.stringify(this.exerciseData));
        this.spinner.hide();
         }else{
          this.createExerciseForTopic();
         }
      }
      
    })
  }
  createExerciseForTopic(){
    this.selfLearnService.createExerciseForTopic().subscribe((res:any) => {
      this.getExamDetails()
      console.log(res);
    })
  }

  navigateToExerciseQuestions(){
    this.close();
    this.router.navigate([`selfLearn-V2/exercise-questions`]);
  }
  close() {
    this.dialogRef.close(false);
  }
  goToNextTopic(){
    let rowIndex = Number(localStorage.getItem('learnTabExpandIndex'))
    localStorage.setItem('learnTabExpandIndex', this.isLastTopic ? '1': ((rowIndex+1)+''));
    this.dialogRef.close(true);
   
  }
  reattemptNow(){
   
    console.log(this.exerciseData.attemps[this.exerciseData.attemps.length-1].attemptnumber)
    this.exerciseData.attemptnumber = this.exerciseData.attemps.length>0?  Number(this.exerciseData.attemps[this.exerciseData.attemps.length-1].attemptnumber)+1 : 1
    localStorage.setItem('exerciseData',JSON.stringify(this.exerciseData));
    console.log(this.exerciseData);
    this.close();
    this.router.navigate([`selfLearn-V2/exercise-questions`]);
    // localStorage.removeItem('exerciseQuestions');
    // localStorage.removeItem('exerciseData');

    // this.selfLearnService.createExerciseForTopic().subscribe((res:any) => {
    //   localStorage.setItem('exerciseQuestions',JSON.stringify(res.data));
    //   this.spinner.hide();
    //   console.log(res);
    //   this.selfLearnService.getExerciseExamDetails().subscribe((res:any) =>{

    //     this.exerciseData = res.report
    //     this.exerciseData = this.exerciseData[this.exerciseData.length-1];
    //     this.accuracy = this.exerciseData.attemps[0]
    //     localStorage.setItem('exerciseData',JSON.stringify(this.exerciseData));
    //     this.spinner.hide();
    //     this.close();
    //     this.router.navigate([`selfLearn-V2/exercise-questions`]);
    //   });
    // })
  }
  viewSolutionForExercise(){
    let viweSolutionPayload:any = {
        "clearcache":true,      
        "attempt": this.exerciseData.attemptnumber.toString(),  
        "ruleid":this.exerciseData.ruleid,        
        "scheduleid":this.exerciseData.sheduleid,       
        "studentid":this.userId.toString()      
    
    }
    localStorage.setItem('viweSolutionPayload',JSON.stringify(viweSolutionPayload));
    this.close();
    this.router.navigate([`selfLearn-V2/exercise-solution`]);
  }
  getExcerciseExamResponses(){
    let payLoad = {
       "scheduleid": this.exerciseData.sheduleid  ,
       "ruleid": this.exerciseData.ruleid,
       "studentid": this.userId,
       "attempt": (this.exerciseData.attemptnumber+1).toString(),
     }
     this.selfLearnService.getExcerciseExamResponses(payLoad).subscribe((res:any) => {
      let result = res;
      if(result.length > 0){
        this.exerciseData.isInprogress = true;
        ++this.exerciseData.attemptnumber;
        this.exerciseData.isSubmitted   = false;
        localStorage.setItem('exerciseData',JSON.stringify(this.exerciseData));
      }
     })
    }
    getPracticeQuestions(){
      this.spinner.show();
      let payload:any = {
          "clearcache":true,      
          "attempt":(this.exerciseData.attemptnumber+1).toString(),    
          "ruleid": this.exerciseData.ruleid,     
          "scheduleid": this.exerciseData.sheduleid,    
          "studentid":this.userId.toString()      
      }
  this.selfLearnService.getPracticeQuestions(payload).subscribe((res:any) =>{
        this.questionsData = res.questions.subjects[0].questions;
       this.spinner.hide();
       
  })
    }

    getNoOfViews(){
      return this.selfLearnService.generateRandomNumber(500, 1000);
    }
}
